export default "__VITE_ASSET__KvyENz03__"